import { useState, useEffect } from "react";
import { NewsResponse, getRFTNews } from "../../../../../../api/news";

export const useRabbitFestivalNews = () => {
  const [topNews, setTopNews] = useState<NewsResponse[]>([]);
  const [newsList, setNewsList] = useState<NewsResponse[]>([]);
  const [search, setSearch] = useState("");
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isFirst, setIsFirst] = useState(true);
  const [loading, setLoading] = useState(true);

  const getData = async () => {
    setLoading(true);

    const res = await getRFTNews(currentPage, 4, search);
    setSearchText(search);
    setTopNews(res.top3);
    setNewsList(res.list);
    setTotalPages(Math.ceil(res.total / 6));
    setTimeout(() => {
      setIsFirst(false);
      setLoading(false);
    }, 50);
  };

  useEffect(() => {
    getData();
  }, [currentPage]);

  useEffect(() => {
    if (!search) getData();
  }, [search]);

  return {
    topNews,
    newsList,
    search,
    setSearch,
    currentPage,
    setCurrentPage,
    getData,
    totalPages,
    isFirst,
    loading,
    searchText,
  };
};
